<template>

   <header id="masthead" :class="classHeader">
      <div :class="classGrid">
        <router-link :to="{ name: routeTo }">
          <a class="logo"></a>
        </router-link>
           <div v-if="showToastError">
          <div
            style="
              margin-bottom: 25px;
              padding: 20px;
              background-color: #ef5451;
              border-radius: 20px;
              color: white;
              display: -webkit-flex;
              display: flex;
              align-items: center;
            "
          >
            <span class="warpit_icon_alert" style="font-size: 32px; margin-right: 15px"></span>
            {{ showToastMessage }}
          </div>
        </div>
      </div>
    </header>
</template>
<script>
export default {
  name:"MasterHead",
  props:{
    classHeader:{
      type:String,
      default:"",
    },
    classGrid:{
      type:String,
      default:"wp1200"
    },
    routeTo:{
      type:String,
      default:"home"
    },
    showToastError:{
      type:Boolean,
      default:false
    },
    showToastMessage:{
      type:String,
      default:""
    }
  }
}
</script>